import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface ICustomerDocument {
    ID: number;
    StorageKey: string;
    IsActive: boolean;
    Description: string;
    FileName: string;
    TempFileKey: string;
    DocumentInUse?: boolean;
}

export function GetAllDocuments(): JQueryDeferred<Data.IResponse<ICustomerDocument[]>> {
    return Util.callWebService(
        "/api/DocumentLibrary/GetAllDocuments",
        "GET");
}

export function Save(docs: ICustomerDocument[]): JQueryDeferred<Data.IResponse<ICustomerDocument[]>> {
    return Util.callWebService(
        "/api/DocumentLibrary/Save",
        "POST",
        docs);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/documentLibraryData.ts